module.exports = __webpack_public_path__ + "img/interviewing-days.39a0a539.svg";